import * as z from "zod";
import { versionSummarySchema } from "./common";

export const listVersions = {
  name: "listVersions" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ versions: z.array(versionSummarySchema) }),
};
